import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { AsyncPlayGround } = await import('./index');
    return {
        Component: AsyncPlayGround,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
